export default {
  SET_MEALS(state, meals) {
    state.meals = meals;
  },
};
